/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum UnloadReason {
  Unknown = 0,
  Background = 1,
  Hibernate = 2,
  Shutdown = 3,
  Crash = 4,
  Reidentify = 5,
  SessionTimeLimit = 6,
}
